/*
 * @Descripttion: 
 * @version: 
 * @Author: yanghui
 * @Date: 2021-09-24 10:45:44
 * @LastEditors: yanghui
 * @LastEditTime: 2021-11-03 10:55:45
 */
import axios from "../../utils/axios";

// 服务订单管理
export function getList(query) {
    return axios({
        url: "serveOrderManage/getList",
        method: "get",
        params: query
    });
}

// 服务订单处理
export function handle(query) {
    return axios({
        url: "serveOrderManage/operate",
        method: "get",
        params: query
    });
}




